// A "report ready" surfaced by the logic engine's `action.report`; App renders a
// banner with an Open button (user-initiated open avoids popup blocking).
import { writable } from 'svelte/store';

export interface ReportReq { name: string; path: string; }
export const reportRequest = writable<ReportReq | null>(null);
